import { useVerticalAppFlag } from '@common/VerticalApps/VerticalAppContext';
import { Tabs } from '@prophecy/ui-v3/Tabs';
import { useSearchParamState } from '@prophecy/utils/react/hooks';
import { useEffect } from 'react';

import { DeployedProjects } from './SqlDeployedProjects';
import { PipelineRuns } from './SqlPipelineRuns';
import { ScheduledPipelines } from './SqlScheduledPipelines';
import { TABS } from './tabs';

export function SQLPipelineObservation() {
  const [tab, setTab] = useSearchParamState('observationTab', {
    initialValue: TABS.DEPLOYED_PROJECTS
  });

  const isVerticalApp = useVerticalAppFlag();

  useEffect(() => {
    if (isVerticalApp && tab === TABS.SCHEDULED_PIPELINES) {
      setTab(TABS.DEPLOYED_PROJECTS);
    }
  }, [isVerticalApp, tab, setTab]);
  return (
    <Tabs variant='underline' activeKey={tab} onChange={(key) => setTab(key)}>
      <Tabs.TabPane tab='Deployed Projects' key={TABS.DEPLOYED_PROJECTS}>
        <DeployedProjects />
      </Tabs.TabPane>
      {!isVerticalApp && (
        <Tabs.TabPane tab='Scheduled Pipelines' key={TABS.SCHEDULED_PIPELINES}>
          <ScheduledPipelines />
        </Tabs.TabPane>
      )}
      <Tabs.TabPane tab='Run History' key={TABS.RUN_HISTORY}>
        <PipelineRuns />
      </Tabs.TabPane>
    </Tabs>
  );
}
